import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './Icon';
import { getUserDisplayName } from '../authStorage';
import { useT } from '../i18n/translations';
import './Sidebar.css';
import logo from '../assets/logo.png';

const NAV_GROUPS = [
  {
    sectionKey: 'nav.home',
    items: [
      { to: '/super-admin/dashboard',         labelKey: 'nav.superAdminDashboard', icon: 'dashboard'    },
    ],
  },
  {
    sectionKey: 'nav.userManagement',
    items: [
      { to: '/super-admin/ceos',              labelKey: 'nav.ceos',                icon: 'user'         },
      { to: '/super-admin/members',           labelKey: 'nav.members',             icon: 'board'        },
      { to: '/super-admin/shareholders',      labelKey: 'nav.shareholders',        icon: 'shareholders' },
    ],
  },
  {
    sectionKey: 'common.decisions',
    items: [
      { to: '/super-admin/decisions',         labelKey: 'common.decisions',        icon: 'decisions'    },
      { to: '/super-admin/packages',          labelKey: 'nav.packages',            icon: 'money'        },
      { to: '/super-admin/subscriptions',     labelKey: 'nav.subscriptions',       icon: 'money'        },
      { to: '/super-admin/contact-messages',  labelKey: 'nav.contactMessages',     icon: 'chat'         },
    ],
  },
];

export default function SuperAdminSidebar({ isOpen, onClose }) {
  const t = useT();
  const [collapsed, setCollapsed] = useState(false);
  const displayName = getUserDisplayName() || t('common.user');

  return (
    <aside className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}${isOpen ? ' sidebar--mobile-open' : ''}`}>
      <div className="sidebar__brand">
        <img src={logo} alt={t('common.brand')} className="sidebar__brand-logo" />
        <div className="sidebar__brand-text">
          <div className="sidebar__brand-name">{t('common.brand')}</div>
          <div className="sidebar__brand-tagline">{t('nav.superAdminTagline')}</div>
        </div>
        <button type="button" className="sidebar__mobile-close" onClick={onClose} aria-label={t('common.closeMenu')}>
          <Icon name="x-circle" size={18} color="rgba(255,255,255,0.7)" />
        </button>
      </div>

      <div className="sidebar__user">
        <div className="sidebar__user-avatar">SA</div>
        <div className="sidebar__user-info">
          <div className="sidebar__user-name">{displayName}</div>
          <div className="sidebar__user-role">{t('nav.fullControl')}</div>
        </div>
        <span className="sidebar__user-dot" />
      </div>

      <nav className="sidebar__nav">
        {NAV_GROUPS.map((group) => (
          <div key={group.sectionKey}>
            <div className="sidebar__section-title">{t(group.sectionKey)}</div>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `sidebar__item${isActive ? ' sidebar__item--active' : ''}`}
                data-label={t(item.labelKey)}
              >
                <span className="sidebar__item-icon">
                  <Icon name={item.icon} size={18} color="rgba(255,255,255,0.85)" />
                </span>
                <span className="sidebar__item-label">{t(item.labelKey)}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <button type="button" className="sidebar__toggle" onClick={() => setCollapsed(!collapsed)}>
        <span className="sidebar__toggle-icon">
          <Icon name={collapsed ? 'chevron-right' : 'chevron-left'} size={15} color="rgba(255,255,255,0.5)" />
        </span>
        <span className="sidebar__toggle-label">{t('common.collapseMenu')}</span>
      </button>
    </aside>
  );
}
